export function makeExistingAttachmentShareSettingsScopeId(attachmentId: string): string {
    return `attachments-${attachmentId}`;
}
